const requestedDocumentPopup = async ({
  token,
  stage,
  serviceType,
  serviceSubType,
  documentList,
}) => {
  try {
    const response = await fetch(
      `https://lvdmsup.nablasol.net/DMS/api/filter_request_document?stage=${stage}&serviceType=${serviceType}&serviceSubType=${serviceSubType}&documentList=${documentList}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default requestedDocumentPopup;
